<script setup lang="ts">
import { computed } from 'vue';

//#region types
interface Props {
  itemsList?: string[],
  trigger?: 'click' | 'hover',
  popperClass?: '',
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  itemsList: () => [],
  trigger: () => 'click',
  popperClass: () => '',
});
//#endregion

const pPopperClass = computed(() => {
  return `${props.popperClass} ui-dropdown__popper`;
});

</script>

<template>
  <div class="ui-dropdown">
    <ElDropdown
      placement="bottom"
      :trigger="props.trigger"
      :popper-class="pPopperClass"
      :popper-style="{
        'z-index': 880
      }"
    >
      <template v-slot>
        <slot name="default" />
      </template>
      <template v-slot:dropdown>
        <ElDropdownMenu class="ui-dropdown__menu">
          <slot name="dropdown">
            <div
              v-for="(item, index) in props.itemsList"
              :key="index"
              class="ui-dropdown__menu-item"
            >
              {{ item }}
            </div>
          </slot>
        </ElDropdownMenu>
      </template>
    </ElDropdown>
  </div>
</template>

<style lang="scss">
.ui-dropdown {
  //&__popper.el-dropdown__popper.el-popper {
  //  border: 1px solid var(--border-default);
  //}
  display: flex;
  align-items: center;
  cursor: pointer;

  &__menu.el-dropdown-menu {
    border-radius: 5px;
    background: #FFF;
  }
  &__menu-item {
    color: var(--text-body);
    font-size: 13px;
    font-weight: 400;
    line-height: 100%;
    padding: 8px 12px;
    cursor: pointer;
    &:hover {
      background: var(--background-brand-subtle);
    }
  }
}
</style>
